import React, { useState } from "react";
import FileUpload from "./FileUpload";
import { renameGroup, renameFileTitle } from "../services/audios";
import { useGlobalState } from "../context/GlobalStateContext";

function FileGroup({
  group,
  files,
  activeFile,
  activeGroup,
  showItem,
  handleClickFile,
  openSection,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedGroupName, setEditedGroupName] = useState(group);
  const [isHoveredEdit, setIsHoveredEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { sendSocketMessage } = useGlobalState();

  const toggleOpen = (group) => {
    openSection(group);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  const handleSaveEdit = async (e) => {
    e.stopPropagation();

    if (editedGroupName.trim() === "" || editedGroupName === group) {
      setIsEditing(false);
      setEditedGroupName(group);
      return;
    }

    setIsLoading(true);
    try {
      await renameGroup(group, editedGroupName.trim());
      console.log(
        "Group renamed successfully from",
        group,
        "to",
        editedGroupName,
      );

      // Refresh the audio list via WebSocket
      sendSocketMessage("REFRESH_AUDIOLIST", null);

      setIsEditing(false);
    } catch (error) {
      console.error("Error renaming group:", error);
      alert("Errore nel rinominare la categoria. Controlla i log.");
      setEditedGroupName(group);
      setIsEditing(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEdit = (e) => {
    e.stopPropagation();
    setEditedGroupName(group);
    setIsEditing(false);
  };

  const handleInputChange = (e) => {
    setEditedGroupName(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSaveEdit(e);
    } else if (e.key === "Escape") {
      handleCancelEdit(e);
    }
  };

  const editIcon = (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginLeft: "8px",
        opacity: isHoveredEdit ? 1 : 0.7,
        cursor: "pointer",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        transform: isHoveredEdit ? "scale(1.1)" : "scale(1)",
        color: isHoveredEdit ? "#d4af37" : "#c9b896",
      }}
      onMouseEnter={() => setIsHoveredEdit(true)}
      onMouseLeave={() => setIsHoveredEdit(false)}
      onClick={handleEditClick}
    >
      <path
        d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (showItem === "group") {
    return (
      <div
        className={
          group === activeGroup ? "file-group open" : "file-group closed"
        }
        onClick={() => toggleOpen(group)}
      >
        <div className="file-group-header_icon">
          {activeGroup && <FileUpload groupName={activeGroup} />}
        </div>
        <div className="file-group-header_title">
          {isEditing && group === activeGroup ? (
            <div
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
              onClick={(e) => e.stopPropagation()}
            >
              <input
                type="text"
                value={editedGroupName}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                autoFocus
                style={{
                  background: "rgba(13, 27, 19, 0.9)",
                  border: "1px solid #7db09a",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  color: "#ffffff",
                  fontSize: "14px",
                  outline: "none",
                  flexGrow: 1,
                }}
              />
              <button
                onClick={handleSaveEdit}
                disabled={isLoading}
                style={{
                  background: "#4a6b5a",
                  border: "none",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  color: "#ffffff",
                  cursor: isLoading ? "wait" : "pointer",
                  fontSize: "12px",
                  opacity: isLoading ? 0.6 : 1,
                }}
              >
                {isLoading ? "⋯" : "✓"}
              </button>
              <button
                onClick={handleCancelEdit}
                disabled={isLoading}
                style={{
                  background: "#6b4a4a",
                  border: "none",
                  borderRadius: "4px",
                  padding: "4px 8px",
                  color: "#ffffff",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  fontSize: "12px",
                  opacity: isLoading ? 0.6 : 1,
                }}
              >
                ✕
              </button>
            </div>
          ) : (
            <>
              <div className="file-group-header_title-content">{group}</div>
              {group === activeGroup && editIcon}
            </>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <>
        {group === activeGroup && (
          <>
            {files.map((file) => (
              <FileItem
                key={file._id}
                file={file}
                activeFile={activeFile}
                handleClickFile={handleClickFile}
              />
            ))}
          </>
        )}
      </>
    );
  }
}

// Componente per singolo file con edit
function FileItem({ file, activeFile, handleClickFile }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedFileTitle, setEditedFileTitle] = useState("");
  const [isHoveredEdit, setIsHoveredEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { sendSocketMessage } = useGlobalState();

  const handleEditClick = (e) => {
    e.stopPropagation();
    // Initialize with current file title
    setEditedFileTitle(file.fileTitle);
    setIsEditing(true);
  };

  const handleSaveEdit = async (e) => {
    e.stopPropagation();

    const trimmedTitle = editedFileTitle.trim();

    if (trimmedTitle === "" || trimmedTitle === file.fileTitle) {
      setIsEditing(false);
      setEditedFileTitle(file.fileTitle);
      return;
    }

    setIsLoading(true);
    try {
      await renameFileTitle(file._id, trimmedTitle);
      console.log("File title updated successfully:", trimmedTitle);

      // Refresh the audio list via WebSocket
      sendSocketMessage("REFRESH_AUDIOLIST", null);

      setIsEditing(false);
    } catch (error) {
      console.error("Error renaming file title:", error);
      alert("Errore nel rinominare il titolo del file. Controlla i log.");
      setEditedFileTitle(file.fileTitle);
      setIsEditing(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEdit = (e) => {
    e.stopPropagation();
    setEditedFileTitle(file.fileTitle);
    setIsEditing(false);
  };

  const handleInputChange = (e) => {
    setEditedFileTitle(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSaveEdit(e);
    } else if (e.key === "Escape") {
      handleCancelEdit(e);
    }
  };

  const editIcon = (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        marginLeft: "8px",
        opacity: isHoveredEdit ? 1 : 0.7,
        cursor: "pointer",
        transition: "opacity 0.2s ease, transform 0.2s ease",
        transform: isHoveredEdit ? "scale(1.1)" : "scale(1)",
        color: isHoveredEdit ? "#d4af37" : "#c9b896",
        flexShrink: 0,
      }}
      onMouseEnter={() => setIsHoveredEdit(true)}
      onMouseLeave={() => setIsHoveredEdit(false)}
      onClick={handleEditClick}
    >
      <path
        d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (isEditing) {
    return (
      <div
        className={
          activeFile && activeFile._id === file._id
            ? "file-group-content_file audio_playing"
            : "file-group-content_file inactive"
        }
        onClick={(e) => e.stopPropagation()}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          justifyContent: "space-between",
        }}
      >
        <input
          type="text"
          value={editedFileTitle}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          autoFocus
          style={{
            background: "rgba(13, 27, 19, 0.9)",
            border: "1px solid #7db09a",
            borderRadius: "4px",
            padding: "4px 8px",
            color: "#ffffff",
            fontSize: "13px",
            outline: "none",
            flexGrow: 1,
            minWidth: 0,
          }}
        />
        <div style={{ display: "flex", gap: "4px", flexShrink: 0 }}>
          <button
            onClick={handleSaveEdit}
            disabled={isLoading}
            style={{
              background: "#4a6b5a",
              border: "none",
              borderRadius: "4px",
              padding: "4px 8px",
              color: "#ffffff",
              cursor: isLoading ? "wait" : "pointer",
              fontSize: "12px",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            {isLoading ? "⋯" : "✓"}
          </button>
          <button
            onClick={handleCancelEdit}
            disabled={isLoading}
            style={{
              background: "#6b4a4a",
              border: "none",
              borderRadius: "4px",
              padding: "4px 8px",
              color: "#ffffff",
              cursor: isLoading ? "not-allowed" : "pointer",
              fontSize: "12px",
              opacity: isLoading ? 0.6 : 1,
            }}
          >
            ✕
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={
        activeFile && activeFile._id === file._id
          ? "file-group-content_file audio_playing"
          : "file-group-content_file inactive"
      }
      onClick={() => handleClickFile(file)}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <span
        style={{
          flexGrow: 1,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {file.fileTitle}
      </span>
      {editIcon}
    </div>
  );
}

export default FileGroup;
